/*
 * Модели на главной: сервинг по окружениям из ArgoCD и чемпион из MLflow.
 * Развёрнутые идут первыми (production выше staging); данные из useResources.
 */
import { AsyncState } from 'react-use/esm/useAsync';
import { routes } from '../../lib/viva';
import { ServingSummary } from '../argocd';
import { AsyncCell, ChampionCell } from '../catalog/cells';
import { modelColumns } from '../catalog/columns';
import { MlModelIcon } from '../icons';
import { ResourceCard } from './ResourceCard';
import { ModelRow, Resources } from './useResources';

const columns = modelColumns<ModelRow>({
  serving: row => (
    <AsyncCell state={row.apps} unavailable="ArgoCD недоступен">
      {apps => (
        <ServingSummary
          apps={apps ?? []}
          modelName={row.entity.metadata.name}
        />
      )}
    </AsyncCell>
  ),
  champion: row => (
    <AsyncCell state={row.summary} unavailable="MLflow недоступен">
      {summary => <ChampionCell entity={row.entity} summary={summary} />}
    </AsyncCell>
  ),
});

export const DeployedModelsCard = ({
  resources,
}: {
  resources: AsyncState<Resources>;
}) => (
  <ResourceCard<ModelRow>
    icon={<MlModelIcon />}
    title="Модели"
    to={routes.models}
    linkText="все модели"
    columns={columns}
    rows={resources.value?.models}
    loading={resources.loading}
    error={resources.error}
    errorTitle="Не удалось загрузить модели"
    emptyText="Моделей пока нет — создайте первую из шаблона «Новая ML-модель»."
    createText="Новая модель"
    createTo={routes.newModel}
  />
);
